import Styled from 'styled-components';

import { media } from '../../../lib/StyledComponents';

const Section = Styled.fieldset`
  margin-bottom: 2em;
  padding-bottom: 1.5em;
  border-bottom: 1px solid ${props => props.theme.colorSlate10};

  &:last-child {
    margin-bottom: 0;
  }

  ${media.medium`
    margin-bottom: 3em;
    padding-bottom: 2em;
  `}
`;

Section.displayName = 'KBASection';

export default Section;
